const hamburger = $(".topbar__button");
const closer = $(".navigation__close");
const navigation = $(".navigation");

hamburger.on("click", function() {
    navigation.css("display", "block");
    setTimeout(() => {
        navigation.addClass("navigation--is-open");
    }, 100);
});

closer.on("click", function() {
    navigation.removeClass("navigation--is-open");
    setTimeout(() => {
        navigation.css("display", "");
    }, 300);
});

// Resize
// ------
var resizeTimer;

$(window).on("resize", function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        navigation.removeClass("navigation--is-open");
        setTimeout(() => {
            navigation.css("display", "");
        }, 300);
    }, 250);
});
